import { createContext } from "react";

const ContextRoute = createContext<any>({});
const ContextBePremiumModal = createContext<any>({});

export {
  ContextRoute,
  ContextBePremiumModal
}
